(function () {
    "use strict";

    // Gallery config
    hs.showCredits = false;
    hs.dimmingOpacity = 0.80;
    hs.dimmingDuration = 300;
    hs.fadeInOut = true;
    hs.transitionDuration = 500;
    hs.align = 'center';
    hs.allowMultipleInstances = false;
    hs.blockRightClick = true;
    hs.captionEval = 'this.a.title';
    hs.outlineType = 'drop-shadow';
    hs.expandCursor = null;
    hs.restoreCursor = null;    

    var lang = document.documentElement.lang.substr(0, 2).toLowerCase();
    
    if (lang == "nl") {
        // Language strings for Dutch
        hs.lang = {
            cssDirection: 'ltr',
            loadingText: 'Laden...',
            loadingTitle: 'Klik om te annuleren',
            focusTitle: 'Klik om naar voren te brengen',
            fullExpandTitle: 'Vergroten naar originele grootte',
            fullExpandText: 'Volledig beeld',
            creditsText: 'Powered by <i>Highslide JS</i>',
            creditsTitle: 'Gaan naar de Highslide JS Homepage',
            previousText: 'Vorige',
            previousTitle: 'Vorige (Pijltje links)',
            nextText: 'Volgende',
            nextTitle: 'Volgende (Pijltje rechts)',
            moveTitle: 'Verplaatsen',
            moveText: 'Verplaatsen',
            closeText: 'Sluiten',
            closeTitle: 'Sluiten (Esc)',
            resizeTitle: 'Grootte herstellen',
            playText: 'Afspelen',
            playTitle: 'Slideshow afspelen',
            pauseText: 'Pauzeren',
            pauseTitle: 'Pauzeer Slideshow',
            number: 'Nummer %1/%2',
            restoreTitle: 'Klik om de afbeelding te sluiten, klik en sleep om het te verplaatsen. Gebruik de pijltjestoetsen om te gaan naar de vorige of volgende.'
        };
    }    

    var swplay = false;

    $(document).ready(function () { setMaxExpanderSize(); });

    hs.Expander.prototype.onShowLoading = function (sender) {
        if ($(sender.a).parents(".gallery-container").length > 0 && hs.getExpander() === null) {
            var imgs = $("img", sender.a);

            if (imgs.length > 0) {
                if ($(imgs[0]).width() > 150) {
                    $(hs.loading).css("margin-left", -1 * ($(imgs[0]).width() - 150) / 2);
                }
                else {
                    $(hs.loading).css("margin-left", 0);
                }

                if ($(imgs[0]).height() > 150) {
                    $(hs.loading).css("margin-top", -1 * ($(imgs[0]).height() - 150) / 2);
                }
                else {
                    $(hs.loading).css("margin-top", 0);
                }
            }
        }
        else {
            $(hs.loading).css("margin-left", 0);
            $(hs.loading).css("margin-top", 0);
        }
    };

    hs.onKeyDown = function (sender, e) {
        if (e.keyCode === 32) {
            swplay = !swplay;
        }
        else if (e.keyCode === 34 || e.keyCode === 39 || e.keyCode === 40 || e.keyCode === 33 || e.keyCode === 37 || e.keyCode === 38 || e.keyCode === 27 || e.keyCode === 13) {
            swplay = false;
        }

        return true;
    };

    hs.Expander.prototype.onInit = function (sender) {
    };

    hs.Expander.prototype.onAfterExpand = function (sender) {
    };

    hs.Expander.prototype.onAfterGetCaption = function (sender) {
        var txt = "";
        var txt2 = "";

        if (typeof (sender.custom.lnk) !== "undefined") { txt = sender.custom.lnk; }
        if (typeof (sender.custom.dlnk) !== "undefined") { txt2 = sender.custom.dlnk; }

        if (txt.length > 0 || txt2.length > 0) {
            var html = "<div class='gallery-caption'><div style='float:right;margin-left:15px;margin-bottom:10px;'>";

            if (txt2.length > 0) html = html + " <a href='" + this.custom.dlnk + "' class='galery-caption-link' title='Download this image' target='_blank'><i class='icon-download-alt'></i> Download</a>";
            if (txt.length > 0) html = html + " <a href='" + this.custom.lnk + "' class='galery-caption-link' title='Permalink to this image (use to share)' target='_blank'><i class='icon-link'></i> Permalink</a>";

            html = html + "</div><div class='gallery-caption-text'>" + sender.caption.innerHTML + "</div></div>";

            sender.caption.innerHTML = html;
        }

        $("li.highslide-play").click(function () {
            swplay = true;
        });

        $("li.highslide-pause").click(function () {
            swplay = false;
        });

        $("li.highslide-previous").click(function () {
            swplay = false;
        });

        $("li.highslide-next").click(function () {
            swplay = false;
        });

        $("li.highslide-close").click(function () {
            swplay = false;
        });
    };

    hs.Expander.prototype.onImageClick = function (sender) {
        swplay = false;
        return true;
    };

    hs.onDimmerClick = function () {
        swplay = false;
        return true;
    };

    hs.addEventListener(window, 'resize', function () {
        centerExpander();
    });

    function centerExpander() {
        setMaxExpanderSize();

        var i, exp;
        hs.getPageSize();

        for (i = 0; i < hs.expanders.length; i++) {
            exp = hs.expanders[i];

            if (exp) {
                var x = exp.x,
                    y = exp.y;

                // get new thumb positions
                exp.tpos = hs.getPosition(exp.el);
                x.calcThumb();
                y.calcThumb();

                // calculate new popup position
                x.pos = x.tpos - x.cb + x.tb;
                x.scroll = hs.page.scrollLeft;
                x.clientSize = hs.page.width;
                y.pos = y.tpos - y.cb + y.tb;
                y.scroll = hs.page.scrollTop;
                y.clientSize = hs.page.height;
                exp.justify(x, true);
                exp.justify(y, true);

                // set new left and top to wrapper and outline
                exp.moveTo(x.pos, y.pos);
            }
        }
    }

    function setMaxExpanderSize() {
        var bspace = 150;

        hs.maxWidth = $(window).width();
        hs.maxHeight = $(window).height() - bspace;
    }

})();    

function setupHighSlideImages(container) {
    // Add highslide class to all linked images in the contianer
    $("a", container).each(function () {
            var imgs = $("img", this);

            if (imgs.length > 0 && !$(this).hasClass("highslide") && ($(this).attr("href").indexOf(".jpg") != -1 || $(this).attr("href").indexOf(".png") != -1)) {
                $(this).addClass("highslide");

                // Replace alignment classes from image element to link element if not in a caption box
                if ($(this).parents(".wp-caption").length === 0)
                {
                    if ($(">img", this).hasClass("alignleft"))
                    {
                        $(this).addClass("alignleft");
                        $(">img", this).removeClass("alignleft");                        
                    }
                    else if ($(">img", this).hasClass("alignright"))
                    {
                        $(this).addClass("alignright");
                        $(">img", this).removeClass("alignright");                        
                    }
                }
            }
        }
    );

    $(".highslide").click(function () {
        return hs.expand(this, { align: 'center', captionEval: 'this.thumb.alt' }, { lnk: '' });
    });
}
